import { useMemo } from 'react';

export function useValidatePassword(password: string) {
  return useMemo(() => {
    const validations = {
      hasMinLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[^A-Za-z0-9]/.test(password),
    };

    const isValid = Object.values(validations).every(Boolean);

    return { ...validations, isValid };
  }, [password]);
}
